import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { ENVIRONMENT } from 'shared';

export const corsInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const environment: any = inject(ENVIRONMENT);
    // Add withCredentials only if the request URL starts with the configured serverUrl
    // and the request does not already have withCredentials set
    if (req.url.startsWith(environment.serverUrl) && !req.withCredentials) {
        const clonedReq = req.clone({ withCredentials: true });
        return next(clonedReq);
    }

    return next(req);
};